import { createFileRoute } from "@tanstack/react-router";
import { ObjectsListPage } from "@/features/customobjects/ObjectsListPage";

export const Route = createFileRoute("/_app/o/")({ component: ObjectsListPage });
